import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { principalIdValidator } from '#validation';
import { CommonMemberCryptoSchema } from '../create/common-member-crypto.schema';
const MemberCryptoUpdateSchema = z.array(CommonMemberCryptoSchema.extend({
    principalId: principalIdValidator({
        requiredError: 'member.principalId.required',
        formatError: 'member.principalId.uuid',
        forbiddenError: 'member.principalId.forbidden',
    }),
}));
export class CommonMemberCryptoUpdateDto extends createZodDto(MemberCryptoUpdateSchema) {
}
